import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

const ExitIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 15V20H20V4H4V9" stroke="currentColor" strokeLinejoin="round" />
    <path d="M3.5 12H15M15 12L11 8M15 12L11 16" stroke="currentColor" />
</svg>
)
const ExitIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ExitIconSvg}
    </SvgIcon>
);
export default ExitIcon
